module.exports = __webpack_public_path__ + "static/media/asset5.06584160.svg";